import React from "react";

import { Grid } from "@material-ui/core";
import { useFormikContext } from "formik";
import { Input, IntegerPriceInput } from "components/Form/FormikControls";
import { FormikAwareBusinessPICSelector } from "components/Form/FormikControls/BusinessPICSelector";
import { Column } from "components/Layout";

import { BUYER } from "constants/businesses";
import { SaleType } from "constants/sale";
import { PricingType } from "components/SellingSaleLotForm/PricingType";
import { ForPaddock } from "containers/ForSaleType";
import { useHasBuyerSplitPermission, useToggle } from "hooks";
import { withNamespace } from "components/Form/FormikControls/lib";
import { FormCollapse } from "components/Form";
import { SubtleBadge } from "components/Badge";

import { TransactionalSaleFormValues } from "../lib/types";
import { FormRow } from "./FormRow";

interface PriceTabProps {
  saleLotNamespace: string;
  saleType?: SaleType | null;
}

export const PriceTab = ({
  saleLotNamespace,
  saleType = null,
}: PriceTabProps) => {
  const formikProps = useFormikContext<TransactionalSaleFormValues>();
  const {
    values: { saleLot },
  } = formikProps;

  const hasBuyerSplitPermission = useHasBuyerSplitPermission();

  const [showMorePricingFields, toggleShowMorePricingFields] = useToggle(false);

  return (
    <>
      <Column gap={8}>
        <Grid item xs={12}>
          <PricingType
            namespace={saleLotNamespace}
            quantity={saleLot.quantity}
            readOnly={false}
            selectedSaleType={saleType}
            hideFields={{ quantity_delivered: true }}
          />
        </Grid>
        <ForPaddock selectedSaleType={saleType}>
          <FormRow>
            <Grid item xs={12}>
              <IntegerPriceInput
                label="Reserve Price"
                name={withNamespace(saleLotNamespace, "reservePrice")}
              />
            </Grid>
          </FormRow>
        </ForPaddock>
      </Column>
      <FormCollapse
        isOpen={showMorePricingFields}
        onToggle={toggleShowMorePricingFields}
        header={<SubtleBadge>More</SubtleBadge>}
      >
        <>
          <Grid xs={12} sm={4} item>
            <Input
              label="Hd Delivered"
              name={withNamespace(saleLotNamespace, "quantity_delivered")}
              type="number"
            />
          </Grid>
          <Grid item xs={12}>
            <FormikAwareBusinessPICSelector
              label="Invoice To"
              businessFieldName={withNamespace(
                saleLotNamespace,
                "invoiceToBusinessId",
              )}
              formikProps={formikProps}
              businessRoles={[BUYER]}
              optional
              clearable
              tooltip={
                hasBuyerSplitPermission
                  ? "The business that receives the invoice for this Sale Lot.  This will" +
                    " be overridden by any Buyer Splits."
                  : ""
              }
            />
          </Grid>
        </>
      </FormCollapse>
    </>
  );
};
